import React from 'react';
import Icon from '../../../components/AppIcon';
import CustomerTableRow from './CustomerTableRow';

const CustomerTable = ({ customers, onCustomerClick, sortField, sortDirection, onSort, canEdit = true, canDelete = true }) => {
  const SortIcon = ({ field }) => {
    if (sortField !== field) {
      return <Icon name="ChevronsUpDown" size={16} className="text-muted-foreground" />;
    }
    return sortDirection === 'asc' 
      ? <Icon name="ChevronUp" size={16} className="text-primary" />
      : <Icon name="ChevronDown" size={16} className="text-primary" />;
  };

  const handleSort = (field) => {
    if (sortField === field) {
      onSort(field, sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      onSort(field, 'asc');
    }
  };

  if (customers?.length === 0) {
    return (
      <div className="bg-card rounded-xl p-8 md:p-12 text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-muted flex items-center justify-center">
          <Icon name="Users" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">No customers found</h3>
        <p className="text-sm text-muted-foreground">Try adjusting your filters or add a new customer to get started.</p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="border-b border-border">
            <tr style={{ background: 'linear-gradient(135deg, #1B3A5C 0%, #2D5580 100%)' }}>
              <th className="px-4 md:px-6 py-3 text-left">
                <button 
                  onClick={() => handleSort('name')}
                  className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-white/90 hover:text-white transition-colors"
                >
                  Customer
                  <Icon name={sortField === 'name' ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={14} className="text-white/70" />
                </button>
              </th>
              <th className="px-4 md:px-6 py-3 text-left hidden md:table-cell">
                <span className="text-xs font-semibold uppercase tracking-wider text-white/90">Phone</span>
              </th>
              <th className="px-4 md:px-6 py-3 text-left">
                <button 
                  onClick={() => handleSort('projectStatus')}
                  className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-white/90 hover:text-white transition-colors"
                >
                  Status
                  <Icon name={sortField === 'projectStatus' ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={14} className="text-white/70" />
                </button>
              </th>
              <th className="px-4 md:px-6 py-3 text-left hidden lg:table-cell">
                <span className="text-xs font-semibold uppercase tracking-wider text-white/90">ADU Type</span>
              </th>
              <th className="px-4 md:px-6 py-3 text-left hidden lg:table-cell">
                <button 
                  onClick={() => handleSort('lastContact')}
                  className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-white/90 hover:text-white transition-colors"
                >
                  Last Contact
                  <Icon name={sortField === 'lastContact' ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={14} className="text-white/70" />
                </button>
              </th>
              <th className="px-4 md:px-6 py-3 text-left">
                <span className="text-xs font-semibold uppercase tracking-wider text-white/90">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {customers?.map((customer) => (
              <CustomerTableRow
                key={customer?.id}
                customer={customer}
                onClick={() => onCustomerClick(customer)}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomerTable;